package com.arena_web.ui.sections.profile.edit

import com.arena_web.ui.theme.AppIcons

data class InterestOption(
    val id: String,
    val label: String,
    val iconSrc: String? = null
)

object InterestCatalog {
    val Sports: List<InterestOption> = listOf(
        InterestOption("football", "Football", AppIcons.BallFootballSmall),
        InterestOption("padel", "Padel", AppIcons.BallPadelSmall),
        InterestOption("basketball", "Basketball", AppIcons.BallBasketballSmall),
        InterestOption("tennis", "Tennis", AppIcons.BallTennisSmall),
        InterestOption("volleyball", "Volleyball", AppIcons.BallVolleyballSmall),
    )

    val Activities: List<InterestOption> = listOf(
        InterestOption("cycling", "Cycling", AppIcons.Cycling),
        InterestOption("gym", "Gym", AppIcons.Gym),
        InterestOption("travel", "Travel", AppIcons.Travel),
        InterestOption("camping", "Camping", AppIcons.Camping),
    )

    val Lifestyle: List<InterestOption> = listOf(
        InterestOption("fishing", "Fishing", AppIcons.Fishing),
        InterestOption("music", "Music", AppIcons.Music),
        InterestOption("reading", "Reading", AppIcons.Reading),
        InterestOption("art", "Art", AppIcons.Art),
        InterestOption("photography", "Photography", AppIcons.Photography),
        InterestOption("cooking", "Cooking", AppIcons.Cooking),
    )

    fun lookup(id: String): InterestOption? =
        Sports.firstOrNull { it.id == id }
            ?: Activities.firstOrNull { it.id == id }
            ?: Lifestyle.firstOrNull { it.id == id }
}
